

<!------------ START TEMPLATE ------------>
<template>
  <div id="data-list-list-view" class="data-list-container">
    <vs-table
      noDataText="Nenhuma testemunha foi encontrado"
      class="tablePrincipal"
      ref="table"
      v-model="selected"
      :data="itens"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div class="flex flex-wrap-reverse items-center">
          <!------------ START ADD NOVO Perfil ------------>
          <div
            class="
              p-3
              mb-4
              mr-4
              rounded-lg
              cursor-pointer
              flex
              items-center
              justify-between
              text-lg
              font-medium
              text-base text-primary
              border border-solid border-primary
            "
            @click="openModalInsertEdit({})"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary"
              >Adicionar testemunha</span
            >
          </div>
        </div>
        <!------------ END ADD NOVO Perfil ------------>
      </div>

      <!------------ START TITULO DA TABELA ------------>

      <template slot="thead">
        <vs-th></vs-th>
        <vs-th sort-key="Nome">Nome</vs-th>
        <vs-th sort-key="Celular">Celular</vs-th>
        <vs-th>Ações</vs-th>
      </template>
      <!------------ END TITULO DA TABELA ------------>

      <!------------ START TABELA ------------>
      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>{{ indextr + 1 }}</vs-td>
            <vs-td>
              <p class="product-category">{{ tr.nome }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.celular }}</p>
            </vs-td>
            <vs-td>
              <p class="product-price">
                <vs-button
                  v-tooltip="'Editar'"
                  radius
                  color="success"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-edit"
                  class="d-inline"
                  @click="openModalInsertEdit(tr)"
                ></vs-button>
              </p>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <!------------ END TABELA ------------>

    <!------------ START INFORMAÇÕES DO Perfil ------------>
    <vs-popup
      class="holamundo"
      :title="titleSideBar"
      :active.sync="modalForm"
      @close="closeModal"
    >
      <div v-if="dadosSideBar">
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input
              class="w-full"
              label="Nome"
              v-model="dadosSideBar.nome"
              name="Nome"
              v-validate="{ required: true }"
              :state="validateState('Nome')"
              :danger="validateClass('Nome')"
            />
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input
              class="w-full"
              label="Email"
              v-model="dadosSideBar.email"
              name="Email"
              v-validate="{ required: true, email: true }"
              :state="validateState('Email')"
              :danger="validateClass('Email')"
            />
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input
              class="w-full"
              label="Telefone"
              v-mask="'(##) ####-####'"
              v-model="dadosSideBar.telefone"
              name="Telefone"
            />
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input
              class="w-full"
              label="Celular"
              v-mask="'(##) #####-####'"
              v-validate="{ required: true }"
              v-model="dadosSideBar.celular"
              name="Celular"
            />
          </div>
        </div>
        <div class="vx-row mt-3">
          <div class="vx-col w-full text-right">
            <form role="form" @submit.stop.prevent="onSaveModalChanges">
              <BotaoSubmit
                variant="success"
                :edit="true"
                :aguarde="false"
              ></BotaoSubmit>
            </form>
          </div>
        </div>
      </div>
    </vs-popup>

    <!------------ END INFORMAÇÕES DO Perfil ------------>
  </div>
</template>
<!------------ START TEMPLATE ------------>


<!------------ START SCRIPT ------------>
<script>
import service from "../../../services";
import BotaoSubmit from "../../../components/BotaoSubmit";

export default {
  components: {
    BotaoSubmit,
  },
  props: ["testemunhas"],
  watch: {
    testemunhas() {
      if (this.testemunhas) {
        this.itens = this.testemunhas;
      }
    },
  },
  data() {
    return {
      modalForm: false,
      dadosSideBar: {},
      formSideBar: "Testemunhas",
      entidade: "Testemunha",
      titleSideBar: "Adicionar Testemunha",
      modalSelecionado: {},
      selected: [],
      itens: [],
      addNewDataSidebar: false,
    };
  },
  methods: {
    closeModal() {
      this.modalForm = false;
      this.dadosSideBar = {};
    },
    salvaOuAtualizaTestemunha() {
      this.$vs.loading();
      this.dadosSideBar = {
        ...this.dadosSideBar,
        idEvento: this.$route.params.idEvento,
      };
      return new Promise((reselve, reject) => {
        service
          .post('Eventos', 'add-atualizaTestemunha', this.dadosSideBar)
          .then((res) => {
            console.log('>>>>>>',res.data);
            if(!Array.isArray(res.data)){
              this.dadosSideBar.idTestemunha = res.data.idTestemunha
            }
            this.$vs.loading.close();
            reselve();
          })
          .catch(() => {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Falha ao atualizar ou cadastrar testemunha',
              color: 'danger',
            });
            this.$vs.loading.close();
            reject();
          });
      });
    },
    async onSaveModalChanges() {
      await this.salvaOuAtualizaTestemunha()
      const index = this.itens.findIndex(
        (item) => item.idTestemunha === this.dadosSideBar.idTestemunha
      );
      if (index >= 0) {
        this.itens[index] = { ...this.dadosSideBar };
      } else {
        this.itens.push(this.dadosSideBar);
      }

      this.modalForm = false;
      this.dadosSideBar = {};
      this.$emit("formAlterado", this.itens);
    },
    buscaDados() {
      this.selected = [];
      this.$vs.loading();

      const objSend = {
        idEvento: this.$route.params.idEvento,
        idEnvolvido: null
      };

      service
        .post("Eventos", "listaTestemunhasPorEvento", objSend)
        .then((res) => {
          if (!this.testemunhas) this.itens = [...res.data];

          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: e,
            color: "danger",
          });
          this.$vs.loading.close();
        });
    },
    openModalInsertEdit(dados) {
      dados.idTestemunha == null
        ? (this.titleSideBar = `Adicionar ${this.entidade} `)
        : (this.titleSideBar = `Editar dados do  ${this.entidade}`);
      this.dadosSideBar = { ...dados };
      this.modalForm = true;
    },
    concluido() {
      this.buscaDados();
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
  },
  mounted() {
    this.buscaDados();
  },
};
</script>
<!------------ END SCRIPT ------------>


<!------------ START STYLE ------------>
<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
<style >
.con-vs-popup .vs-popup {
  width: 1000px !important;
}
</style>
<!------------ END STYLE ------------>
